"use client";
import { jsx } from "react/jsx-runtime";
import { useMemo, lazy } from "react";
import { MakeswiftHostApiClient } from "../../../api/react";
import { ReactRuntimeContext } from "../hooks/use-react-runtime";
import { MakeswiftHostApiClientProvider } from "../host-api-client";
const LiveProvider = lazy(() => import("./LiveProvider"));
const PreviewProvider = lazy(() => import("./PreviewProvider"));
function ReactRuntimeProvider({
  children,
  runtime,
  previewMode,
  apiOrigin = "https://api.makeswift.com",
  locale = void 0
}) {
  const client = useMemo(
    () => new MakeswiftHostApiClient({
      uri: new URL("graphql", apiOrigin).href,
      locale
    }),
    [apiOrigin, locale]
  );
  const StoreProvider = previewMode ? PreviewProvider : LiveProvider;
  return /* @__PURE__ */ jsx(ReactRuntimeContext.Provider, { value: runtime, children: /* @__PURE__ */ jsx(MakeswiftHostApiClientProvider, { client, children: /* @__PURE__ */ jsx(StoreProvider, { children }) }) });
}
export {
  ReactRuntimeProvider
};
//# sourceMappingURL=RuntimeProvider.js.map